var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode"},[_c('div',{ref:"qrcode"}),(_vm.showText)?_c('p',{staticClass:"text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }